function initClient() {
  var API_KEY = 'AIzaSyBKXFUTfvJc_499k0MXD3v3I7E97ADzHJo'; // TODO: Update placeholder with desired API key.

  var CLIENT_ID =
    '1011179671912-isn33b8okueu5f1pvqbsc0k6v2ije0qs.apps.googleusercontent.com'; // TODO: Update placeholder with desired client ID.

  // TODO: Authorize using one of the following scopes:
  //   'https://www.googleapis.com/auth/drive'
  //   'https://www.googleapis.com/auth/drive.file'
  //   'https://www.googleapis.com/auth/drive.readonly'
  //   'https://www.googleapis.com/auth/spreadsheets'
  //   'https://www.googleapis.com/auth/spreadsheets.readonly'
  var SCOPE = 'https://www.googleapis.com/auth/spreadsheets.readonly';

  gapi.client
    .init({
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      scope: SCOPE,
      discoveryDocs: [
        'https://sheets.googleapis.com/$discovery/rest?version=v4',
      ],
    })
    .then(function () {
      gapi.auth2.getAuthInstance().isSignedIn.listen(updateSignInStatus);
      updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
    });
}

function handleClientLoad() {
  gapi.load('client:auth2', initClient);
}

function updateSignInStatus() {
  read_data('data_tab');
}
let dataQuery;

function read_data(type) {
  let ranges;
  if (type && type === 'data_tab') {
    ranges = ['dulieuloaitab'];
  } else if (type && type === 'data_column') {
    ranges = ['dulieuloaibang'];
  } else if (type && type === 'data_row') {
    ranges = ['noidungbang'];
  }
  gapi.client.sheets.spreadsheets.values
    .batchGet({
      spreadsheetId: '1RjWFT6Cuuwp3OcaTd2C_NUUjlEkP8NUguUV_fSw8oG0',
      ranges: ranges,
    })
    .then((response) => {
      if (type && type === 'data_tab') {
        init(response.result);
      } else if (type && type === 'data_column') {
        tabInit(response.result);
      } else if (type && type === 'data_row') {
        rowInit(response.result);
      }
    });
}
function init(res) {
  if (res && res.valueRanges[0].values.length > 1) {
    for (let i = 0; i < res.valueRanges[0].values.length; i++) {
      const value = res.valueRanges[0].values[i];
      const button = document.createElement('button');
      button.setAttribute('type', 'button');
      button.setAttribute('data-txt-type', 'tab__' + value[1]);
      button.setAttribute('onclick', 'begin(event, "tab__' + value[1] + '")');
      if (i === 0) button.setAttribute('id', 'defaultOpen');
      button.className = 'product-tab__link';
      button.innerHTML = value[0];
      document.querySelector('.product-tab__links').append(button);
    }
    read_data('data_column');
  }
}
function tabInit(res) {
  if (res && res.valueRanges[0].values.length > 1) {
    for (let i = 0; i < res.valueRanges[0].values.length; i++) {
      const value = res.valueRanges[0].values[i];
      const div = document.createElement('div');
      div.setAttribute('id', 'tab__' + value[1]);
      div.setAttribute('data-tab', 'tab__' + value[2]);
      div.className = 'product-tab__content';
      div.innerHTML = `
      <div class="pt-wrapper">
        <div class="pt-info flex space-between align-center hidden-phone hidden-desktop hidden-tablet">
          <div class="pt-info__item">
            <span class="page-title-h5"></span>
          </div>
          <div class="pt-info__item flex space-between align-center">
            <span class="page-title-h5">Giá mới</span>
            <span class="page-title-h5">Giá thu mua cũ</span>
          </div>
        </div>
        <div class="pt-inner" data-txt-id="content__${value[1]}">
        </div>
      </div>
      `;
      const tb_rendering = document.createElement('div');
      tb_rendering.setAttribute('data-tb', value[1]);
      tb_rendering.setAttribute('data-tb-txt', value[2]);
      tb_rendering.className = 'tb-rendering';
      tb_rendering.innerHTML = `<div class="tb-name flex space-between align-center">
      <span>${value[0]}</span>
      <span>
        <span class="close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_614_15006)">
        <path d="M8.43906 3.86151L15.8191 11.262C16.0607 11.5044 16.0603 11.897 15.8178 12.1391C15.5753 12.3809 15.1826 12.3803 14.9407 12.1378L7.99997 5.17785L1.05925 12.1381C0.817376 12.3805 0.424847 12.3812 0.182347 12.1393C0.0607853 12.018 3.79453e-06 11.859 3.78758e-06 11.7C3.78065e-06 11.5415 0.060379 11.3831 0.181097 11.262L7.56091 3.86151C7.6771 3.74473 7.83522 3.6792 7.99997 3.6792C8.16472 3.6792 8.32266 3.74492 8.43906 3.86151Z" fill="#121212"/>
        </g>
        <defs>
        <clipPath id="clip0_614_15006">
        <rect width="16" height="16" fill="white" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 16 16)"/>
        </clipPath>
        </defs>
        </svg>
        </span>
        <span class="open"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_614_16167)">
        <path d="M8.43906 12.1385L15.8191 4.73802C16.0607 4.49555 16.0603 4.10299 15.8178 3.86093C15.5753 3.61906 15.1826 3.61968 14.9407 3.86218L7.99997 10.8222L1.05925 3.86193C0.817376 3.61946 0.424847 3.61884 0.182347 3.86068C0.0607853 3.98202 3.79453e-06 4.14099 3.78758e-06 4.29996C3.78065e-06 4.45852 0.060379 4.61686 0.181097 4.73799L7.56091 12.1385C7.6771 12.2553 7.83522 12.3208 7.99997 12.3208C8.16472 12.3208 8.32266 12.2551 8.43906 12.1385Z" fill="#121212"/>
        </g>
        <defs>
        <clipPath id="clip0_614_16167">
        <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)"/>
        </clipPath>
        </defs>
        </svg>
        </span>
      </span>
    </div>`;
      document.querySelector('#hidden-rendering').append(tb_rendering);
      document.querySelector('.product-tab__contents').append(div);
    }
    read_data('data_row');
    const defaultOpen = document.getElementById('defaultOpen');
    if (defaultOpen) defaultOpen.click();
  }
}
function rowInit(res) {
  if (res && res.valueRanges[0].values.length > 1) {
    for (let i = 0; i < res.valueRanges[0].values.length; i++) {
      const value = res.valueRanges[0].values[i];
      const name = value[0],
        code = value[1],
        image = value[2];

      const value_array_1 =
        value[4] !== undefined && value[4] !== '' ? value[4].split('\n') : '';
      const value_array_2 =
        value[6] !== undefined && value[6] !== '' ? value[6].split('\n') : '';
      const value_array_3 =
        value[8] !== undefined && value[8] !== '' ? value[8].split('\n') : '';
      const value_array_4 =
        value[10] !== undefined && value[10] !== ''
          ? value[10].split('\n')
          : '';
      const value_array_5 =
        value[12] !== undefined && value[12] !== ''
          ? value[12].split('\n')
          : '';
      const value_array_6 =
        value[14] !== undefined && value[14] !== ''
          ? value[14].split('\n')
          : '';
      const value_array_7 =
        value[16] !== undefined && value[16] !== ''
          ? value[16].split('\n')
          : '';
      const value_array_8 =
        value[18] !== undefined && value[18] !== ''
          ? value[18].split('\n')
          : '';
      const value_array_9 =
        value[20] !== undefined && value[20] !== ''
          ? value[20].split('\n')
          : '';
      const value_array_10 =
        value[22] !== undefined && value[22] !== ''
          ? value[22].split('\n')
          : '';
      const value_array_11 =
        value[24] !== undefined && value[24] !== ''
          ? value[24].split('\n')
          : '';
      const value_array_12 =
        value[26] !== undefined && value[26] !== ''
          ? value[26].split('\n')
          : '';
      const value_array_13 =
        value[28] !== undefined && value[28] !== ''
          ? value[28].split('\n')
          : '';
      const value_array_14 =
        value[30] !== undefined && value[30] !== ''
          ? value[30].split('\n')
          : '';
      const value_array_15 =
        value[32] !== undefined && value[32] !== ''
          ? value[32].split('\n')
          : '';
      const value_array_16 =
        value[34] !== undefined && value[34] !== ''
          ? value[34].split('\n')
          : '';
      const value_array_17 =
        value[36] !== undefined && value[36] !== ''
          ? value[36].split('\n')
          : '';
      const value_array_18 =
        value[38] !== undefined && value[38] !== ''
          ? value[38].split('\n')
          : '';
      const value_array_19 =
        value[40] !== undefined && value[40] !== ''
          ? value[40].split('\n')
          : '';
      const array = [
        {
          name: value[3],
          value: value[4],
        },
        {
          name: value[5],
          value: value[6],
        },
        {
          name: value[7],
          value: value[8],
        },
        {
          name: value[9],
          value: value[10],
        },
        {
          name: value[11],
          value: value[12],
        },
        {
          name: value[13],
          value: value[14],
        },
        {
          name: value[15],
          value: value[16],
        },
        {
          name: value[17],
          value: value[18],
        },
        {
          name: value[19],
          value: value[20],
        },
        {
          name: value[21],
          value: value[22],
        },
        {
          name: value[23],
          value: value[24],
        },
        {
          name: value[25],
          value: value[26],
        },
        {
          name: value[27],
          value: value[28],
        },
        {
          name: value[29],
          value: value[30],
        },
        {
          name: value[31],
          value: value[32],
        },
        {
          name: value[33],
          value: value[34],
        },
        {
          name: value[35],
          value: value[36],
        },
        {
          name: value[37],
          value: value[38],
        },
        {
          name: value[39],
          value: value[40],
        },
      ];
      const tb_rendering_item = document.createElement('div');
      tb_rendering_item.setAttribute('data-target', code);
      tb_rendering_item.innerHTML = `
          <div class="tb-image">
            <img
            class="lazyload"
            data-src="${image}"
            alt="">
          </div>
          <div class="tb-content">
            <div class="pt-info__model">
               <span>${name}</span>
            </div>
            <div class="pt-info flex space-between align-center">
              <div class="pt-info__item">
              </div>
              <div class="pt-info__item flex space-between align-center">
                <span class="page-title-h5">Giá mới</span>
                <span class="page-title-h5">Giá cũ</span>
              </div>
            </div>
            ${
              array[0].name !== '' && array[0].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[0].name}</div>
            <div class="tb-item__content">
              <p>${value_array_1[0] ? value_array_1[0] : ''}</p>
              <p>${value_array_1[1] ? value_array_1[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[1].name !== '' && array[1].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[1].name}</div>
            <div class="tb-item__content">
            <p>${value_array_2[0] ? value_array_2[0] : ''}</p>
            <p>${value_array_2[1] ? value_array_2[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[2].name !== '' && array[2].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[2].name}</div>
            <div class="tb-item__content">
            <p>${value_array_3[0] ? value_array_3[0] : ''}</p>
            <p>${value_array_3[1] ? value_array_3[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[3].name !== '' && array[3].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[3].name}</div>
            <div class="tb-item__content">
            <p>${value_array_4[0] ? value_array_4[0] : ''}</p>
            <p>${value_array_4[1] ? value_array_4[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[4].name !== '' && array[4].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[4].name}</div>
            <div class="tb-item__content">
            <p>${value_array_5[0] ? value_array_5[0] : ''}</p>
            <p>${value_array_5[1] ? value_array_5[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[5].name !== '' && array[5].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[5].name}</div>
            <div class="tb-item__content">
            <p>${value_array_6[0] ? value_array_6[0] : ''}</p>
            <p>${value_array_6[1] ? value_array_6[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[6].name !== '' && array[6].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[6].name}</div>
            <div class="tb-item__content">
            <p>${value_array_7[0] ? value_array_7[0] : ''}</p>
            <p>${value_array_7[1] ? value_array_7[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[7].name !== '' && array[7].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[7].name}</div>
            <div class="tb-item__content">
            <p>${value_array_8[0] ? value_array_8[0] : ''}</p>
            <p>${value_array_8[1] ? value_array_8[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[8].name !== '' && array[8].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_9[0] ? value_array_9[0] : ''}</p>
            <p>${value_array_9[1] ? value_array_9[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[9].name !== '' && array[9].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_10[0] ? value_array_10[0] : ''}</p>
            <p>${value_array_10[1] ? value_array_10[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[10].name !== '' && array[10].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_11[0] ? value_array_11[0] : ''}</p>
            <p>${value_array_11[1] ? value_array_11[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[11].name !== '' && array[11].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_11[0] ? value_array_11[0] : ''}</p>
            <p>${value_array_11[1] ? value_array_11[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[12].name !== '' && array[12].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_12[0] ? value_array_12[0] : ''}</p>
            <p>${value_array_12[1] ? value_array_12[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[13].name !== '' && array[13].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_13[0] ? value_array_13[0] : ''}</p>
            <p>${value_array_13[1] ? value_array_13[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[14].name !== '' && array[14].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_14[0] ? value_array_14[0] : ''}</p>
            <p>${value_array_14[1] ? value_array_14[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[15].name !== '' && array[15].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_15[0] ? value_array_15[0] : ''}</p>
            <p>${value_array_15[1] ? value_array_15[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[16].name !== '' && array[16].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_16[0] ? value_array_16[0] : ''}</p>
            <p>${value_array_16[1] ? value_array_16[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[17].name !== '' && array[17].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_17[0] ? value_array_17[0] : ''}</p>
            <p>${value_array_17[1] ? value_array_11[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
            
            ${
              array[18].name !== '' && array[18].name !== undefined
                ? `<div class="flex space-between align-center tb-item">
            <div class="tb-item__title">${array[8].name}</div>
            <div class="tb-item__content">
            <p>${value_array_18[0] ? value_array_18[0] : ''}</p>
            <p>${value_array_18[1] ? value_array_18[1] : ''}</p>
            </div>
          </div>`
                : ''
            }
        </div>
      `;
      tb_rendering_item.className = 'tb-rendering__item';
      document.querySelector('#hidden-rendering').append(tb_rendering_item);
    }
    render();
  }
}
function render() {
  const renderings = document.querySelectorAll('.tb-rendering');
  renderings.forEach((current) => {
    const element = document.createElement('div');
    const data_target = current.getAttribute('data-tb');
    const data_target_txt = current.getAttribute('data-tb-txt');
    const found = document.querySelector(
      `.pt-inner[data-txt-id="content__${data_target}"]`
    );

    const title = current.querySelector('.tb-name');
    element.append(title);
    element.className = 'tb-table';
    element.setAttribute('data-tb', data_target);
    element.setAttribute('data-tb-txt', data_target_txt);
    if (found) {
      found.append(element);
    }
  });

  const renderings_item = document.querySelectorAll('.tb-rendering__item');
  renderings_item.forEach((current) => {
    const data_target = current.getAttribute('data-target');
    const found = document.querySelector(`[data-tb-txt="${data_target}"]`);
    if (found) {
      found.append(current);
    }
  });

  const titles = document.querySelectorAll('.tb-name');
  titles.forEach((current) => {
    current.addEventListener('click', function () {
      current.parentNode.classList.toggle('active');
    });
  });
}
